import React, { Component } from "react";
import { connect } from "react-redux";
import { DIMENSIONS } from "services/layoutManager";
import * as StorageUtils from "utils/StorageUtils";
import { StorageApi } from "services/storage";
import { TICKET_TYPES } from "utils/TicketConstants";
import BloxPage from "sub_components/Layout/BloxPage";
import ComponentWrapper from "sub_components/Layout/ComponentWrapper";
import DonutChart from "sub_components/Common/DonutChart";
import { LargeInfoDisplay } from "styled_components/Common/LargeInfoDisplay";
import { RESOLUTIONS } from "services/config";
import {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
} from "actions/siteTracking";
import { MENU as STORAGE_MENU } from "utils/StorageConstants";
import { SITE_PAGES, SITE_MODULES } from "utils/CommonConstants";
import { Utils } from "services/utils";
import { updateShares } from "actions/storage";
import { Permissions } from "services/permissions";
import { BloxButton } from "styled_components/Common/BloxButton";
import { setHomeTour } from "actions/tour";
import { SharesBody } from "blox_components/Storage/StorageOverviewDetail/Components/SharesBody";
import ObjectGraphs from "blox_components/Storage/Graphs/ObjectGraphs";
import StorageUsage from "blox_components/Storage/Graphs/StorageUsage";
import { updatePermissions } from "actions/permissions";
import { JoyRideToolTip } from "styled_components/Common/JoyRideToolTip";
import { getUserPermissions, setUserPermissions } from "services/user";
import Joyride from "react-joyride-react-19";
import { TicketApi } from "services/ticket";

const LAYOUT_CONFIG = {
  [RESOLUTIONS.MIN]: {
    graphs: { x: 1, y: 26, dim: DIMENSIONS.FOUR_BY_SIX },
    sharesScroller: { x: 8, y: 26, dim: DIMENSIONS.FOUR_BY_FOUR },
    ticketDonut: { x: 10, y: 1, dim: DIMENSIONS.TWO_BY_TWO },
    addStorage: { x: 1, y: 1, dim: DIMENSIONS.TWO_BY_SIX },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.LOW]: {
    graphs: { x: 1, y: 26, dim: DIMENSIONS.FOUR_BY_SIX },
    sharesScroller: { x: 8, y: 26, dim: DIMENSIONS.FOUR_BY_FOUR },
    ticketDonut: { x: 10, y: 1, dim: DIMENSIONS.TWO_BY_TWO },
    addStorage: { x: 1, y: 1, dim: DIMENSIONS.TWO_BY_SIX },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.MED]: {
    graphs: { x: 1, y: 32, dim: DIMENSIONS.FOUR_BY_SIX },
    sharesScroller: { x: 8, y: 32, dim: DIMENSIONS.FOUR_BY_FOUR },
    ticketDonut: { x: 10, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    addStorage: { x: 1, y: 0, dim: DIMENSIONS.TWO_BY_SIX },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.HIGH]: {
    graphs: { x: 1, y: 58, dim: DIMENSIONS.FOUR_BY_SIX },
    sharesScroller: { x: 8, y: 58, dim: DIMENSIONS.FOUR_BY_FOUR },
    ticketDonut: { x: 10, y: 1, dim: DIMENSIONS.TWO_BY_TWO },
    addStorage: { x: 1, y: 1, dim: DIMENSIONS.TWO_BY_SIX },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
};

class OverviewPage extends Component {
  constructor() {
    super();
    this.state = {
      showTitleTicketCount: true,
      pages: null,
      storageStats: null,
      objectCommitmentSizeType: null,
      graphData: null,
      resolution: "hour",
      series: [],
      categories: [],
      unit: "",
      commitment_amount: null,
      runTour: false,
    };
  }
  componentDidMount() {
    const {
      updateModule,
      updatePage,
      addPageToBreadCrumbs,
      site,
      permissions,
      location,
      setHomeTour,
    } = this.props;
    updatePage(SITE_PAGES.STORAGE[STORAGE_MENU.OVERVIEW]);
    addPageToBreadCrumbs(
      SITE_PAGES.STORAGE[STORAGE_MENU.OVERVIEW],
      SITE_MODULES.STORAGE
    );
    if (site?.module !== "STORAGE" || !permissions?.permissions) {
      this.getModulePages();
    }
    updateModule(SITE_MODULES.STORAGE);
    const search = location?.search;

    if (search.includes("tour=true")) {
      setHomeTour({ runHomeTour: true, action: "start" });
      this.setState({ runTour: true });
    }
    this.grabStorageInfo();
    this.getStorageStats();
    this.getInitialOverviewGraphData();
    Utils.showHorizontalBar();
    this.getTicketType("storage");
  }

  componentWillUnmount() {
    Utils.removeHorizontalBar();
  }
  componentDidUpdate(prevProps) {
    const { location, setHomeTour } = this.props;

    const search = location?.search;
    const prevSearch = prevProps?.location?.search;

    if (search !== prevSearch && search.includes("tour=true")) {
      this.setState({ runTour: true });
      setHomeTour({ runHomeTour: true, action: "start" });
    }
  }

  getModulePages = async () => {
    const {
      updatePermissions,
      auth_status: {
        user: { id: userId },
      },
      company_info: {
        customer: { id: orgId },
      },
    } = this.props;
    //check cache
    const permissions = getUserPermissions("storage");
    if (!permissions) {
      const response = await Permissions.getModulePermissions(1, userId, orgId);
      if (response && !response.data.error) {
        setUserPermissions("storage", response.data.pages);
        updatePermissions(response.data.pages);
      }
    } else {
      updatePermissions(permissions);
    }
  };

  getPackage = (data, type) => {
    let totalCommitment;
    const { packages } = data;
    if (packages.length) {
      totalCommitment = packages.filter(
        (storagePackage) => storagePackage.storageType === type
      );
      return totalCommitment[0];
    }
  };

  getCommitmentSize = (pkg, data) => {
    let shareSize = null;
    let commitmentSizeType = null;
    if (pkg?.commitmentAmountMB && pkg?.commitmentAmountMB < 1000) {
      shareSize = pkg.commitmentAmountMB;
      commitmentSizeType = "MB";
    } else if (pkg?.commitmentAmountGB && pkg?.commitmentAmountGB < 1000) {
      shareSize = pkg.commitmentAmountGB;
      commitmentSizeType = "GB";
    } else if (pkg?.commitmentAmountTB && pkg?.commitmentAmountTB < 1000) {
      shareSize = pkg.commitmentAmountTB;
      commitmentSizeType = "TB";
    } else {
      if (pkg?.commitmentAmountPB) {
        shareSize = pkg?.commitmentAmountPB;
        commitmentSizeType = "PB";
      } else {
        shareSize = pkg?.commitmentAmountMB;
        commitmentSizeType = "MB";
      }
    }

    if (pkg?.storageType === "object") {
      this.setObjectCommittment(shareSize, commitmentSizeType, data, pkg);
    } else {
      this.setState({ fileCommitmentSizeType: commitmentSizeType });
    }
    return shareSize;
  };

  setObjectCommittment = (shareSize, commitmentSizeType, data, pkg) => {
    if (shareSize && shareSize !== 0) {
      this.setState({ objectCommitmentSizeType: commitmentSizeType });
    } else {
      const usageUnit =
        data[pkg?.storageType].length === 1
          ? StorageUtils.determineDataUnit(data, pkg?.storageType)
          : data[pkg?.storageType].reduce((type, item) =>
              StorageUtils.determineDataUnit(item, type)
            );

      this.setState({ objectCommitmentSizeType: usageUnit });
    }
  };

  showTitleTicketCount = (show) => {
    const { showTitleTicketCount } = this.state;

    if (showTitleTicketCount !== show) {
      this.setState({ showTitleTicketCount: show });
    }
  };

  checkShares = (shares, type) => {
    if (!shares) {
      return false;
    }

    if (shares.length) {
      const share = shares.filter((share) => share.type === type);
      if (share.length === 0) {
        return false;
      } else {
        return share.length;
      }
    }
    return false;
  };

  goToTicketHistory = (status, type) => {
    const { navigate } = this.props;
    navigate("/portal/support/ticket_history", { state: { status, type } });
  };

  grabStorageInfo = () => {
    const {
      updateShares,
      company_info: {
        customer: { id },
      },
    } = this.props;

    StorageApi.getAll(id)
      .then((response) => {
        const validResponse = !response.error && response.storages;

        if (validResponse) {
          const storages = StorageUtils.sortShares(response.storages);
          updateShares(response.storages);
          const fileShare = this.checkShares(response.storages, "file");
          const objectShare = this.checkShares(response.storages, "object");

          this.setState({ storages, fileShare, objectShare, loading: false });
        } else {
          this.setState({
            error: "Error pulling storage details",
            loading: false,
          });
        }
      })
      .catch((error) => console.log(error));
  };
  getStorageStats = () => {
    const {
      company_info: {
        customer: { id },
      },
    } = this.props;
    StorageApi.getStorageStats(id)
      .then((response) => {
        const validResponse = response.status === 200 && response.data;
        if (validResponse) {
          const filePackage = this.getPackage(response.data, "file");
          const objectPackage = this.getPackage(response.data, "object");
          const objectCommitment = this.getCommitmentSize(
            objectPackage,
            response.data
          );

          if (objectPackage) {
            this.setState({
              objectCommitment,
            });
          }
          if (filePackage) {
            const fileCommitment = this.getCommitmentSize(filePackage);
            this.setState({
              fileCommitment,
            });
          }
          this.setState({
            storageStats: response.data,
          });
        } else {
          this.setState({ error: "Error pulling storage stat details" });
        }
      })
      .catch((error) => {
        this.setState({ error });
      });
  };
  getInitialOverviewGraphData = () => {
    const { resolution } = this.state;
    const {
      company_info: {
        customer: { id },
      },
    } = this.props;

    StorageApi.getInitialStorageGraphData("overview", resolution, id)
      .then((response) => {
        const validResponse = !response.error && response.series;

        if (validResponse) {
          const { series, categories, unit, commitment_amount } = response;
          this.setState({
            commitment_amount,
            series,
            categories,
            unit,
          });
        } else {
          this.setState({ error: "Error pulling storage graph details" });
        }
      })
      .catch((error) => {
        this.setState({ error });
      });
  };

  getPackageData = (data, type) => {
    if (!data || !data.packages || !type) return null;

    const matches = data.packages.filter(
      (packageInfo) => packageInfo.storageType === type
    );
    return matches && matches[0] ? matches[0] : null;
  };

  calculateTotalUsage = (data, type, unit = null) => {
    let usageUnit;

    if (unit) {
      usageUnit = unit;
    } else if (data[type].length !== 0) {
      usageUnit =
        data[type].length === 1
          ? StorageUtils.determineDataUnit(data, type)
          : data[type].reduce((type, item) =>
              StorageUtils.determineDataUnit(item, type)
            );
    }
    if (data[type] && data[type].length !== 0) {
      let totalUsage = data[type].reduce(
        // eslint-disable-next-line
        (total, location) => (total += location[`size${usageUnit}`]),
        0
      );

      if (isNaN(totalUsage)) {
        return { totalUsage: 0, unit: "mb" };
      } else {
        totalUsage = totalUsage.toFixed(2);
        return { totalUsage, unit: usageUnit };
      }
    } else {
      return { totalUsage: 0, unit: "mb" };
    }
  };

  getTicketType = (type) => {
    TicketApi.getTicketType(type)
      .then((response) => {
        if (response.status === 200 && response?.data && !response.data.error) {
          this.setState({ ticketType: response?.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  loadMoreData = async (page) => {
    const {
      resolution,
      unit,
      categories: currentCategories,
      series: currentSeries,
    } = this.state;
    const {
      company_info: {
        customer: { id },
      },
    } = this.props;
    await StorageApi.getStorageGraphData("overview", resolution, unit, page, id)
      .then((response) => {
        const validResponse = !response.error && response.series;
        if (validResponse) {
          const { unit, series, categories, commitment_amount } = response;

          if (currentCategories) {
            currentCategories.push(...categories);
          }
          if (currentSeries) {
            currentSeries.forEach((current) => {
              series.map((data) => {
                if (current.name === data.name) {
                  const newData = data.data;
                  current.data.push(...newData);
                }
              });
            });
          }

          this.setState({
            series: currentSeries,
            categories: currentCategories,
            unit,
            loading: false,
            commitment_amount,
          });
        } else {
          this.setState({ error: "Error pulling storage graph data" });
        }
      })
      .catch((error) => console.log(error));
  };

  setResolution = (resolution) => {
    const resolutionLower = resolution && resolution.toLowerCase();
    this.setState(
      { resolution: resolutionLower, series: [], categories: [] },
      () => this.getInitialOverviewGraphData()
    );
  };

  closeTour = (joyride) => {
    const { setHomeTour, navigate } = this.props;
    const action = joyride?.action;
    if (action === "close" || action === "reset" || action === "stop") {
      setHomeTour({ runHomeTour: false, action });
      this.setState({ runTour: false });
      navigate("/portal/storage");
    }
  };

  render() {
    const {
      breakpoint,
      location,
      site,
      navigate,
      permissions: pages,
      company_info: {
        customer: { id },
      },
    } = this.props;

    const {
      storageStats: stats,
      objectCommitment: total,
      objectShare,
      storages: shares,
      unit,
      series,
      categories,
      commitment_amount,
      runTour,
      ticketType,
    } = this.state;

    const { showTitleTicketCount } = this.state;

    const ViewTicketStatus = Permissions.checkComponentAccess(
      pages,
      "Storage Overview",
      "view-ticket-status"
    );

    const ViewStorageObjectAccess = Permissions.checkComponentAccess(
      pages,
      "Storage Overview",
      "view-storage-object"
    );

    const ViewStorageListAccess = Permissions.checkComponentAccess(
      pages,
      "Storage Overview",
      "view-storage-list"
    );
    //FIX THIS PAGE
    const packageData = this.getPackageData(stats, "object");

    const { totalUsage } = stats
      ? this.calculateTotalUsage(stats, "object", unit)
      : { totalUsage: null };
    const moduleOrder = location?.state?.moduleOrder;
    const steps = [
      {
        title: "Storage Overview",
        content:
          "This module is your window into your cloud storage environment. In here, you can manage the storage network, add new storage, delete the old stuff you no longer need, and track utilization.",
        placement: "center",
        locale: { skip: "S-K-I-P" },
        target: ".header-section",
        module: "storage",
      },
      {
        target: ".storage-usage-wrapper",
        content:
          "Your current storage utilization across all storage containers is shown here as well as what data center your storage is located in.",
        module: "storage",
      },
      {
        target: ".overview-graph",
        content:
          "This is a trend graph that shows the distribution of storage utilization over time. Here you see an hourly view.",
        module: "storage",
      },
      {
        target: "#large-info-card-shares",
        content:
          "Storage is divided into Shares, and in a share, you can have several documents. If you click on a share, I will show you some basic information about that share.",
        module: "storage",
      },
      // {
      // 	target: '.donut-chart-container',
      // 	content:
      // 		'Up here, I will show you support tickets specific to the Storage module. Don't forget you can click on these doughnuts.',
      // 	module: 'storage',
      // },
      {
        target: ".header-section",
        module: "storage",
        disableBeacon: true,
        customNextButton: (
          <BloxButton
            className="buttons41"
            id="continue-tour"
            text="Next"
            module="storage"
            enabled={true}
            onClick={() =>
              navigate("/portal/storage/share_detail?tour=true", {
                state: { moduleOrder },
              })
            }
            cypressId="continue-tour"
          />
        ),
        placement: "center",
        content: "Next, I will take you to the Share Detail Page.",
      },
    ];

    return (
      <BloxPage
        name="sample-content-grid storage"
        layout={LAYOUT_CONFIG[breakpoint]}
        breakpoint={breakpoint}
        location={location}
      >
        <div key={`tourButton`} className="tourButton">
          {pages && (
            <Joyride
              steps={steps}
              continuous={true}
              showProgress
              showSkipButton
              styles={{
                options: {
                  zIndex: 5000,
                },
              }}
              tooltipComponent={JoyRideToolTip}
              run={runTour}
              disableScrolling={true}
              callback={this.closeTour}
              disableOverlayClose={true}
            />
          )}
        </div>
        <div key={`ticketDonut`} className="ticketDonut">
          {ViewTicketStatus && (
            <ComponentWrapper
              site={site}
              breakpoint={breakpoint}
              title={showTitleTicketCount ? "Storage Tickets" : ""}
              hideBorder
              titleClass="center"
            >
              <DonutChart
                ticketType={TICKET_TYPES.STORAGE}
                showTitle={this.showTitleTicketCount}
                goToTicketHistory={this.goToTicketHistory}
                id="storage"
                breakpoint={breakpoint}
                pages={pages}
                ticketTypePermission={ticketType}
                site={site?.module}
              />
            </ComponentWrapper>
          )}
        </div>
        <div key={`graphs`} className="graphs">
          {ViewStorageObjectAccess && (
            <ComponentWrapper title="Object Storage" hideBorder>
              <ObjectGraphs
                pages={pages}
                breakpoint={breakpoint}
                data={stats}
                objectCommitment={total}
                objectCommitmentSizeType={unit}
                objectShare={objectShare}
                unit={unit}
                series={series}
                categories={categories}
                commitment_amount={commitment_amount}
                loadMoreData={this.loadMoreData}
                setResolution={this.setResolution}
              />
            </ComponentWrapper>
          )}
        </div>
        <div key={`sharesScroller`} className="sharesScroller">
          {ViewStorageListAccess && (
            <ComponentWrapper title="Shares">
              <LargeInfoDisplay
                type="customBody"
                customBody={
                  <SharesBody
                    data={shares}
                    total={total}
                    unit={unit}
                    orgId={id}
                    navigate={navigate}
                  />
                }
                data={null}
                module="storage"
                cypressId="share-scroller"
                navigate={navigate}
                id="shares"
              />
            </ComponentWrapper>
          )}
        </div>
        <div key={`addStorage`} className="storageDetails">
          {ViewStorageObjectAccess && (
            <ComponentWrapper
              title={
                totalUsage && unit ? `Total Usage ${totalUsage} ${unit}` : ""
              }
              hideBorder
            >
              <StorageUsage
                data={stats}
                total={commitment_amount}
                unit={unit}
                breakpoint={breakpoint}
                navigate={navigate}
                packageData={packageData}
                usage={totalUsage}
              />
            </ComponentWrapper>
          )}
        </div>
      </BloxPage>
    );
  }
}
function mapStateToProps(state) {
  return {
    site: state.site_tracking,
    storage: state.storage,
    permissions: state.permissions,
    company_info: state.company_info,
    auth_status: state.auth_status,
  };
}

export default connect(mapStateToProps, {
  updateModule,
  updatePage,
  updateShares,
  addPageToBreadCrumbs,
  updatePermissions,
  setHomeTour,
})(OverviewPage);
